import 'dayjs/locale/es';

import { Box } from '@mui/material';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';

import PurchaseOrders from './components/PurchaseOrders';
import Summary from './components/Summary';
import Suppliers from './components/Suppliers';
import Tenders from './components/Tenders';

const PublicMarket = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <EnhancedTab
        startValue={0}
        tabs={[
          {
            label: 'Resumen',
            component: <Summary />,
          },
          {
            label: 'Licitaciones',
            component: <Tenders />,
          },
          {
            label: 'Ordenes de compra',
            component: <PurchaseOrders />,
          },
          {
            label: 'Proveedores',
            component: <Suppliers />,
          },
        ]}
      />
    </Box>
  );
};

export default PublicMarket;
